import { Row, Col } from "react-bootstrap";
import { PrivilegeSelect } from "./PrivilegeSelect";
import type { PrivilegeDefinition } from "../types";

export interface PrivilegeSectionProps {
  title: string;
  definitions: PrivilegeDefinition[];
  values: Record<string, string>;
  onChange: (privilegeId: string, level: string) => void;
}

// Split the scope's privileges into rows of two so each visual row can carry a
// bottom divider.
const toPairs = (defs: PrivilegeDefinition[]): PrivilegeDefinition[][] => {
  const pairs: PrivilegeDefinition[][] = [];
  for (let i = 0; i < defs.length; i += 2) {
    pairs.push(defs.slice(i, i + 2));
  }
  return pairs;
};

export const PrivilegeSection = ({
  title,
  definitions,
  values,
  onChange,
}: PrivilegeSectionProps): JSX.Element | null => {
  if (definitions.length === 0) return null;
  return (
    <section className="mt-5">
      <h5 className="mb-3">{title}</h5>
      {toPairs(definitions).map((pair, i) => (
        <Row key={i} className="border-bottom pb-3 mb-3">
          {pair.map((def) => (
            <Col sm={6} key={def.id}>
              <PrivilegeSelect
                definition={def}
                value={values[def.id] ?? ""}
                onChange={(level) => onChange(def.id, level)}
              />
            </Col>
          ))}
        </Row>
      ))}
    </section>
  );
};

export default PrivilegeSection;
